module.exports = __webpack_public_path__ + "img/logo-explicae.6240ad38.svg";